// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7GQvC","top":"styles_top__3nvis","left":"styles_left__3LASe","description":"styles_description__3Hj7T"};